<template>
  <div>
    <div class="flex flex-col items-center mt-8 intro-y sm:flex-row">
      <div class="flex items-center w-full mr-auto text-lg font-medium">
        จัดการลำดับ Highlight
      </div>
    </div>
    <div
      class="flex items-center justify-between mt-4 mb-4 intro-y sm:flex-row"
    ></div>
    <div class="table intro-y">
      <draggable
        v-model="gethering"
        item-key="no"
        v-bind="dragOptions"
        @change="onMoveCallback"
        @start="drag = true"
        @end="drag = false"
      >
        <template #item="{element, index}">
          <div
            class="inline-block text-gray-700 bg-white cursor-move inbox__item sm:block dark:text-gray-500"
          >
            <div class="flex px-5 py-3 my-2 space-x-3">
              <MenuIcon class="w-5 h-5" />
              <div class="mx-4">{{ index + 1 }}</div>
              <div>{{ element.title }}</div>
            </div>
          </div>
        </template>
      </draggable>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import draggable from "vuedraggable";
import * as getheringService from "/src/services/gethering";
export default defineComponent({
  components: {
    draggable
  },
  setup() {
    const dragOptions = {
      animation: 300,
      disabled: false,
      ghostClass: "ghost"
    };
    const gethering = ref([]);

    const onMoveCallback = () => {
      let orders = [];
      gethering.value.map((item, index) => {
        item.no = index + 1;
        orders.push(item.id);
      });
      getheringService
        .orderGethering(orders)
        .then(() => {})
        .catch(() => {});
    };

    onMounted(() => {
      getGethering();
    });
    const getGethering = () => {
      getheringService
        .getListByOrder()
        .then(res => {
          gethering.value = res.data.data;
        })
        .catch(() => {});
    };
    return {
      dragOptions,
      gethering,
      onMoveCallback,
      getGethering
    };
  }
});
</script>

<style lang="scss" scoped>
.ghost {
  @apply bg-gray-300;
  @apply text-gray-500;
}
</style>
